(function($){

  // only run code below on Campaign content types
  if (document.querySelector('body').classList.contains('page-node-type-campaign-page')) {

    // get intro body text container for campaign page
    let campaignBody = document.querySelector('.block-field-blocknodecampaign-pagebody');

    // get form ID to user as button anchor
    let formId = document.querySelector('.component--callout-with-form .form-wrapper .webform-ajax-form-wrapper').getAttribute('id');

    // create new CTA button with href anchor to form (show only for mobile)
    let newButton = document.createElement('a');
    newButton.textContent = "Learn More";
    newButton.classList.add("button--red", "margin-bottom-30", "d-lg-none");
    newButton.setAttribute('href', '#' + formId); // empty anchor to make sure pointer events get applied

    // make sure there's a form on the sidebar...
    if (formId) {
      // add click event to smooth scroll to form below
      newButton.addEventListener('click', (e)=>{
        $('html, body').animate({
          scrollTop: $('#' + formId).offset().top - 230, // - 200px offset to account for form's heading/text
        }, 500, 'easeInOutExpo');
      })
    }

    // add button at the end of container
    campaignBody.appendChild(newButton);

  }
})(jQuery);
